export default class AdditionalInsurance {
  public hasAdditionalInsurance = false;
  public insurerName: string | undefined;
  public policyNumber: string | undefined;
  public contactPhoneNumber: string | undefined;
  public contactPhoneNumberExtension: number | undefined;
}
